<template>
  <div>
    <AutoComplete
      v-model="selectedSubcategory"
      :label="'Subcategory Level ' + depth"
      :placeholder="'Select Subcategory Level ' + depth"
      :serializer="(val) => val"
      endpoint="category-list"
      text-title="name"
      :otherQuery="`filter[parent_id]=${category.id}`"
      @input="onSubcategorySelected"
    />
    <div v-if="shouldRenderChildCategory">
      <recursive-category-auto-complete
        :category="selectedSubcategory"
        :depth="depth + 1"
        @final-value="emitFinalValue"
      />
    </div>
  </div>
</template>

<script>
const AutoComplete = () => import('./AutoComplete.vue');

export default {
  name: 'RecursiveCategoryAutoComplete',
  components: {
    AutoComplete,
  },

  props: {
    category: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      selectedSubcategory: null,
    };
  },

  computed: {
    shouldRenderChildCategory() {
      return (
        this.selectedSubcategory &&
        this.selectedSubcategory.childs &&
        this.selectedSubcategory.childs.length > 0
      );
    },
  },
  methods: {
    onSubcategorySelected(value) {
      this.$emit('final-value', value);
    },
    emitFinalValue(value) {
      // If the subcategory has no children, emit the category as the final value
      if (!value) {
        this.$emit('final-value', this.category);
      } else {
        this.$emit('final-value', value);
      }
    },
  },
};
</script>
./RecursiveCategoryAutoComplete.vue
